// Set platform variables
window.isOptima = true;
window.isKadmin = false;
window.isTABS = false;
// any CSS you require will output into a single css file (app.css in this case)
import '../scss/main.scss';
// App js for all the functionality
import './app.js';
